import { REDIRECT } from '@/constants/common/urls';
import { cookie } from '@/imports-files/common/common';
import { WebsiteCookies } from '@/actions/common/website-cookies';
import Url from 'url-parse';
import { CommunicationCount } from '@/services/common/communication-count';

export async function ProtectedRoutes(router, session) {
  // const client_login_url = REDIRECT.client.login;
  const admin_login_url = REDIRECT.admins.login;
  const agency_login_url = REDIRECT.agency.login;
  const admin_home_url = REDIRECT.admins.dashboard.activities;
  const client_home_url = REDIRECT.client.activities;
  const agency_home_url = REDIRECT.agency.dashboard.activities;

  const website_cookies = new WebsiteCookies();
  let session_type = session?.type;
  switch (session_type) {
    case "Admin":
      AdminRoutesProtection(admin_home_url, router, admin_login_url)
      break;
    case "ClientUser":
      ClientRoutesProtection(client_home_url, router, session)
      break;
    case "AgencyUser":
      AgencyRoutesProtection(agency_home_url, router, session)
      break;
    default:
      if (router.pathname.includes('/admins/dashboard/')) { router.push(process.env.NEXT_PUBLIC_BASE_URL + admin_login_url) }
      else if (router.pathname.includes('/clients/dashboard/')) {
        router.replace({pathname: process.env.NEXT_PUBLIC_HEARTPACE_DEFAULT_URL})
      }
      else if (router.pathname.includes('/agency/dashboard/')) {
        router.push(process.env.NEXT_PUBLIC_BASE_URL + agency_login_url)
      }
      else if(router.pathname == '/'){
        let redirectUrl = process.env.NEXT_PUBLIC_HEARTPACE_DEFAULT_URL + '/recruit/error'
        window.location.replace(redirectUrl + `?error=sign_in_failed&reason=auth_payload_missing`)
      }
  }
}

function AdminRoutesProtection(admin_home_url, router, admin_login_url) {
  const basePath = process.env.NEXT_PUBLIC_BASE_URL;
  let pathname = router.pathname
  pathname = pathname.replace(basePath, '');
  //as we are allowing Candidly Admin to view client pages
  if (pathname.startsWith("/clients/welcome") || pathname.startsWith("/admins/login") || pathname.startsWith("/agency/welcome")) {
    router.push(admin_home_url);
  }
}

// TODO: Need to be test with the client routes
function ClientRoutesProtection(client_home_url, router, session) {
  const basePath = process.env.NEXT_PUBLIC_BASE_URL;
  let pathname = router.pathname
  pathname = pathname.replace(basePath, '');
  let asPath = router.asPath;
  const new_host = get_new_host();
  const agency_host = agency_new_host(session);

  //Subdomain checking if user try to access another subdomain url
  // if (!is_url_belongs_to_client(new_host) && !is_url_belongs_to_client(agency_host)) {
  if (!is_url_belongs_to_client(new_host) && !is_url_belongs_to_client(agency_host)) {
    window.location.replace(new_host + client_home_url);
  }

  if (!pathname.startsWith("/clients/dashboard/") && !pathname.startsWith("/agency/dashboard/")) {
    if (!(pathname.includes('view-job') ||
      pathname.includes("/application-sent") ||
      pathname.includes("/confirm-email") ||
      pathname.includes('offer-detail') ||
      pathname.includes('sign-contract') ||
      pathname.includes("/careers") ||
      pathname.includes("/job-openings") ||
      pathname.includes("/application/view-profile") ||
      pathname.includes("/application/general-profile") ||
      pathname.includes("/offers/approval-page") ||
      asPath.includes("integration-connected") ||
      pathname.includes('interviews/select-time-slot') ||
      pathname.includes('pre-deletion-confirm') ||
      pathname.includes('/jobs/approval-page') ||
      pathname.includes('/clients/branding/email-branding') ||
      //  NOTE :- This line will be remove
      pathname.includes('/templates/email-templates') ||
      pathname.includes('/video/introduction') ||
      pathname.includes('/candidate/record-video') ||
      pathname.includes('/download-scorecard') ||
      pathname.includes('/view-candidate-cv') ||
      pathname.includes('/submit-screening-questions')
      )) {
      router.push(new_host + client_home_url);
    }
  }
}

function AgencyRoutesProtection(agency_home_url, router, session)
{
    const basePath             =   process.env.NEXT_PUBLIC_BASE_URL;
    let pathname               =   router.pathname
    pathname                   =   pathname.replace(basePath,'');
    let asPath                 =   router.asPath;
    const new_host             =   get_new_host();
    const agency_host          =   agency_new_host(session);
    //Subdomain checking if user try to access another subdomain url
    if(!is_url_belongs_to_client(new_host) && !is_url_belongs_to_client(agency_host))
    {
      window.location.replace(new_host + agency_home_url);
    }
    if (!pathname.startsWith("/clients/dashboard/") && !pathname.startsWith("/agency/dashboard/"))
    {
      if(!(pathname.includes('view-job') ||
           pathname.includes("/application-sent") ||
           pathname.includes("/confirm-email") ||
           pathname.includes('offer-detail') ||
           pathname.includes('sign-contract') ||
           pathname.includes("/careers") ||
           pathname.includes("/job-openings") ||
           pathname.includes("/application/view-profile")||
           pathname.includes("/application/general-profile") ||
           pathname.includes("/offers/approval-page") ||
           asPath.includes("integration-connected") ||
           pathname.includes('interviews/select-time-slot')||
           pathname.includes('pre-deletion-confirm')||
          pathname.includes('/jobs/approval-page')||
          //  NOTE :- This line will be remove
           pathname.includes('/templates/email-templates')||
           pathname.includes('/video/introduction') ||
           pathname.includes('/candidate/record-video') ||
           pathname.includes('/download-scorecard') ||
           pathname.includes('/view-candidate-cv') ||
           pathname.includes('/submit-screening-questions')
           ))
      {
        router.push(agency_host+agency_home_url);
      }
    }
}


function is_url_belongs_to_client(new_host) {
  if (window.location.host.startsWith('jobs') ||
    window.location.host.startsWith('offers') ||
    window.location.pathname.includes('interviews/select-time-slot') ||
    window.location.pathname.includes('/integration-connected') ||
    window.location.pathname.includes('/video/introduction') ||
    window.location.pathname.includes('/candidate/record-video') ||
    window.location.pathname.includes('/download-scorecard') ||
    window.location.pathname.includes('/submit-screening-questions') ||
    window.location.pathname.includes("/application/view-profile") ||
    window.location.pathname.includes("/application/general-profile") ||
    window.location.pathname.includes("/careers") ||
    window.location.pathname.includes("/job-openings") ||
    window.location.pathname.includes('/pre-deletion-confirm')
    ) {
    return true;
  }
  else {
    return typeof new_host == "object" ? new_host.filter((x) => window.location.href.includes(x)).length > 0 : window.location.href.includes(new_host);
  }
}

export function get_new_host() {

  let new_host = null;
  let subdomain = new WebsiteCookies().getCookie('subdomain');
  let host = Url(process.env.NEXT_PUBLIC_BASE_URL).host
  if (subdomain.length > 0) {
    new_host = window.location.protocol + '//' + subdomain + '.' + host;
  }
  else {
    new_host = window.location.protocol + '//' + host;
  }
  return new_host;
}

export function get_public_link_host(subdomain) {
  let new_host = null;
  let host = Url(process.env.NEXT_PUBLIC_BASE_URL).host
  if (subdomain.length > 0) {
    new_host = window.location.protocol + '//' + subdomain + '.' + host;
  }
  else {
    new_host = window.location.protocol + '//' + host;
  }
  return new_host;
}

export async function getCommunicationCount(setCountCommunication, setFlagForRender) {
  var result = await new CommunicationCount().getCount();
  setCountCommunication(result?.data?.unread_count || 0);
}
export function agency_new_host(session) {

  let new_host = [];
  let subdomain = new WebsiteCookies().getCookie('agency_subdomain');
  let host = Url(process.env.NEXT_PUBLIC_BASE_URL).host
  if (subdomain.length > 0) {
    session?.all_agency_domains?.map((x) => {
      new_host.push(window.location.protocol + '//' + x + '.' + host)
    })
    // new_host = window.location.protocol + '//' + subdomain + '.' + host;
  }
  else {
    new_host = [window.location.protocol + '//' + host];
  }
  return new_host;
}